/**
 * Chat API Utility
 */

import { apiClient } from "./apiClient";

const normalizeMessage = (message) => {
  if (!message) return message;
  return {
    id: message.id,
    sender_id: message.sender_id ?? message.sender,
    receiver_id: message.receiver_id ?? message.receiver,
    content: message.content,
    timestamp: message.timestamp,
    read: message.read ?? message.is_read ?? false,
  };
};

const normalizeMessages = (messages = []) =>
  messages.map((message) => normalizeMessage(message));

export const chatAPI = {
  getAccessibleOrganizations: () => apiClient.get("/organizations/accessible/"),

  getConversations: (organizationId) =>
    apiClient.get(`/chat/org/${organizationId}/conversations/`),

  getChatUsers: (organizationId) =>
    apiClient.get(`/chat/org/${organizationId}/users/`),

  getMessages: async (organizationId, otherUserId) => {
    const messages = await apiClient.get(
      `/chat/org/${organizationId}/?user_id=${otherUserId}`,
    );
    return normalizeMessages(messages);
  },

  sendMessage: async (organizationId, messageData) => {
    const message = await apiClient.post(
      `/chat/org/${organizationId}/`,
      messageData,
    );
    return normalizeMessage(message);
  },

  markAsRead: (organizationId, messageId) =>
    apiClient.post(`/chat/org/${organizationId}/messages/${messageId}/read/`),
};
